export enum BasketErrors {
    CustomerNotFound = 'customerNotFound',
    Default = 'defaultError',
    MissingToken = 'missingTokenSession',
    InvalidProductId = 'invalidProductId',
}
